// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg',
)({
  component: RouteComponent,
  staticData: { crumb: 'service-manager:services.jyskEnergi.title' },
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { managedAccountId } = useParams({
    from: '/$accountId/_admin/service-manager/$managedAccountId/jyskenergiesg',
  });

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title={t('services.jyskEnergi.title')}
          action={
            <ServiceActivationSwitch
              managedAccountId={managedAccountId}
              servicePath="jyskenergiesg"
              ariaLabel={t('services.jyskEnergi.title')}
            />
          }
          slotProps={{
            title: { variant: 'h6', fontWeight: 600 }
          }}
        />
        <Divider />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {t('services.jyskEnergi.description')}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}
